const COLOR_CLASSES = {
    EXCEEDS: "rating-blue",
    MEETS: "rating-green",
    APPROACHING: "rating-orange",
    "DOES NOT MEET": "rating-red"
};

export const RATING_DISPLAY_LABELS = {
    EXCEEDS: "Exceeds",
    MEETS: "Meets",
    APPROACHING: "Approaching",
    "DOES NOT MEET": "Does Not Meet"
};

export const RATING_OPTIONS = ["EXCEEDS", "MEETS", "APPROACHING", "DOES NOT MEET"];

export const getColorClass = (rating) => (rating ? COLOR_CLASSES[rating] : "");

export const getFormattedHeaderAndTitle = (body, maxLength = 25) => {
    const matchShorthand = body.match(/\(([^)]+)\)\s*$/);
    const prefix = `${matchShorthand ? matchShorthand[1] : ""}`;

    const sentenceStart = body.split(".")[0].trim();
    const shortDescription =
        sentenceStart.length > maxLength ? sentenceStart.slice(0, maxLength).trim() + "…" : sentenceStart;

    const header = `${shortDescription}`;
    return { header, shortTitle: prefix };
};

export const extractStudentGradingProfileId = (key) => {
    return parseInt(key.includes("-") ? key.split("-")[1] : key, 10);
};

export const buildGroupInfoDto = (groupData, selectedEpr, selectedTemplate) => {
    const teacherHomeroomGroups = groupData
        .filter((g) => g.groupType === "GROUP" && !g.shareGroupId)
        .map((g) => ({ groupId: g.groupId }));

    const sharedGroupInfos = groupData
        .filter((g) => g.groupType === "SHARED" || !!g.shareGroupId)
        .map((g) => ({
            sharedGradingProfile: g.gradingProfileId,
            sharedGradingCriteria: g.sharedGradingCriteria,
            sharedGroupId: g.groupId
        }));

    const gradingCriteriaId = selectedEpr.gradingCriteriaList.find(
        (c) => parseInt(c.parentTemplate, 10) === selectedTemplate.templateId
    )?.key;

    return {
        teacherGradingProfile: selectedEpr.key,
        teacherGradingCriteria: gradingCriteriaId,
        teacherHomeroomGroups,
        sharedGroupInfos
    };
};

export const mapRatingSubmission = ({
    ratings,
    contentItems,
    existingRatingsData,
    selectedEpr,
    selectedTemplate,
    userDetails,
    groupData = []
}) => {
    const templateId = selectedTemplate.templateId;

    return Object.entries(ratings)
        .map(([key, rating]) => {
            const [studentKey, templateContentId] = key.split("_");
            const templateContentIdNum = Number(templateContentId);

            const studentId = studentKey.includes("-") ? Number(studentKey.split("-")[1]) : Number(studentKey);

            const groupId = studentKey.includes("-") ? Number(studentKey.split("-")[0]) : null;

            const group = groupData.find((g) => g.groupId === groupId);

            const gradingCriteriaId = group?.shareGroupId
                ? group.sharedGradingCriteria
                : selectedEpr.gradingCriteriaList.find((c) => parseInt(c.parentTemplate, 10) === templateId)?.key;

            const existingStudent = existingRatingsData?.find((s) => s.key === studentKey);

            const existingRating = existingStudent?.contentRatings?.find(
                (r) => r.templateContentId === templateContentIdNum
            );

            return {
                key: existingRating?.key || null,
                gradingProfileStudentId: studentId,
                gradingCriteria: Number(gradingCriteriaId),
                templateContentId: templateContentIdNum,
                contentType:
                    contentItems.find((c) => c.templateContentId === templateContentIdNum)?.contentType || "GLE",
                rating: rating === "DOES NOT MEET" ? "DOES_NOT_MEET" : rating,
                comment: existingRating?.comment ?? null,
                personalizedLearningPlan: false,
                lastRatedGuid: userDetails?.uid
            };
        })
        .filter((item) => !(item.key === null && item.rating === null));
};

export const normalizeRating = (backendValue) => {
    if (backendValue === "DOES_NOT_MEET") return "DOES NOT MEET";
    return backendValue;
};

export const getGradingCriteriaId = (student, groupData, selectedEpr, selectedTemplate, mode) => {
    const templateId = selectedTemplate.templateId;

    if (mode === "GROUPS") {
        const group = groupData?.find((g) =>
            g.groupStudentContents.some(
                (s) => s.gradingProfileStudentId.toString() === extractStudentGradingProfileId(student.key).toString()
            )
        );

        if (group?.shareGroupId) {
            return group.sharedGradingCriteria;
        }

        return selectedEpr.gradingCriteriaList.find((c) => parseInt(c.parentTemplate, 10) === templateId)?.key;
    }

    return selectedEpr.gradingCriteriaList.find((c) => parseInt(c.parentTemplate, 10) === templateId)?.key;
};

export const buildGroupFetchPayload = ({ selectedGroups, selectedEpr, selectedTemplate }) => {
    if (!selectedEpr || !selectedTemplate) return null;

    const teacherGradingProfile = parseInt(selectedEpr.key, 10);
    const teacherGradingCriteria = selectedEpr.gradingCriteriaList.find(
        (criteria) => parseInt(criteria.parentTemplate, 10) === selectedTemplate.templateId
    )?.key;

    const payload = {
        teacherGradingProfile,
        teacherGradingCriteria: parseInt(teacherGradingCriteria, 10),
        teacherHomeroomGroups: [],
        sharedGroupInfos: []
    };

    selectedGroups.forEach((group) => {
        const [, idString] = group.value.split("-");
        const id = Number(idString);

        if (group.groupType === "HOMEROOM") {
            payload.teacherHomeroomGroups.push({ groupId: id });
        } else if (group.groupType === "SHARED") {
            const meta = group.sharedMeta;
            payload.sharedGroupInfos.push({
                sharedGradingProfile: meta.sharedGradingProfile,
                sharedGradingCriteria: meta.sharedGradingCriteria,
                sharedGroupId: meta.sharedGroupId
            });
        }
    });

    return payload;
};
